import BaseAPI from "../api";


const path: string = "roles";


export type roles_type = {
    roles_name: string;
    status: string;
    permission: any;
    id_roles?: number | null;
    // is_engineer:boolean;
    // is_supervisor:boolean;
    // is_admin_manager:boolean;
}

export type roles_list = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
}

export class RolesApi extends BaseAPI {
    static getList(): Promise<any> {
        return this.api.get(`${path}`)
    }
    static create(body: roles_type): Promise<any> {
        return this.api.post(`${path}`, body)
    }
    static update(id_roles: number, body: roles_type): Promise<any> {
        return this.api.patch(`${path}/${id_roles}`, body)
    }
    static updateStatus(id_roles: number, body: { status: string }): Promise<any> {
        return this.api.patch(`${path}/${id_roles}`, body)
    }
    static findOne(id_roles: number): Promise<any> {
        return this.api.get(`${path}/find/one/${id_roles}`)
    }
    static list(query: roles_list): Promise<any> {
        return this.api.get(`${path}/find/list`, { params: { ...query } })
    }
}